<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">Reportes</div>
      <div slot="sub-title">Generar y revisar gráficos</div>
      <div slot="right">
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <card-component  class="has-table has-mobile-sort-spaced">
      <b-tabs class="dark-tabs" type="is-boxed" v-model="activeTab" slot="content">
        <b-tab-item label="Informe de Resultados">
          <results-report></results-report>
        </b-tab-item>
        <b-tab-item label="Rendimiento por Ejercicio">
          <lesson-comparation-chart ></lesson-comparation-chart>
        </b-tab-item>
        <b-tab-item label="Rendimiento por Lección">
          <rider-performance-chart class="card-content-padding"></rider-performance-chart>
        </b-tab-item>
        <b-tab-item label="Tabla Pivote">
          <exercise-details-pivot-table></exercise-details-pivot-table>
        </b-tab-item>
      </b-tabs>
      </card-component>
    </section>
  </div>
</template>

<script>

import HeroBar from '@/components/HeroBar'
import CardComponent from '@/components/CardComponent'
import LessonComparationChart from './exercise_performance/LessonComparationChart'
import ResultsReport from './results_report/ResultsReport'
import RiderPerformanceChart from './rider_horse_performance/RiderPerformanceChart'
import ExerciseDetailsPivotTable from './pivot/ExerciseDetailsPivotTable'

export default {
  components: {
    HeroBar,
    CardComponent,
    LessonComparationChart,
    RiderPerformanceChart,
    ExerciseDetailsPivotTable,
    ResultsReport
  },
  data () {
    return {
      activeTab: 0
    }
  }
}
</script>
